module.exports = __webpack_public_path__ + "static/img/b1.2325cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b1.png
// module id = jt0N
// module chunks = 1